<template>
  <div v-if="element && entryItems">
    <template v-if="element.omit">
      <v-icon v-if="!omitted" @click="toggle">visibility</v-icon>
      <v-icon v-if="omitted" @click="toggle">visibility_off</v-icon>
    </template>
    <div :class="blockStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "OmitBlock",
  props: ["element", "entryItems"],
  computed: {
    entryItem() {
      if (!this.entryItems) {
        return undefined;
      }
      return this.entryItems[this.element.id];
    },
    blockStyle() {
      if (!this.element.omit) {
        return "blockvisible";
      }
      return this.entryItem.booleanValue ? "blockgrayed" : "blockvisible";
    },
    omitted() {
      if (!this.element.omit) {
        return false;
      }
      return this.entryItem.booleanValue;
    }
  },
  methods: {
    toggle() {
      // let copy = Object.assign({}, this.element);
      let copy = JSON.parse(JSON.stringify(this.entryItems));
      if (copy[this.element.id]) {
        copy[this.element.id].booleanValue = !copy[this.element.id]
          .booleanValue;
        this.$emit("updated", copy);
      }
    }
  }
};
</script>

<style scoped>
.blockvisible {
  display: block;
}
.blockgrayed {
  display: block;
  opacity: 0.3;
  filter: grayscale(100%);
  pointer-events: none;
  background: #dddddd;
}
</style>